(function() {
    'use strict';
    angular
        .module('jmrsignApp')
        .factory('AppAccountSvc', AppAccountSvc);

    AppAccountSvc.$inject = ['$resource'];

    function AppAccountSvc ($resource) {
        var resourceUrl =  'api/accounts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
